import { Injectable, inject } from '@angular/core';
import { take } from 'rxjs';
import { NotFoundError } from '../../errors';
import { SurveyAnswer } from '../../models';
import { EvaluateSurveyService } from '../../services';
import { SurveysService } from '../../services/surveys';

@Injectable()
export class EvaluateSurveyResources {
  private surveys = inject(SurveysService);
  private evaluator = inject(EvaluateSurveyService);

  async getSurveyData(reference: string) {
    const templateDoc = await this.surveys.getSurveyTemplate(reference);

    const surveyTemplate = templateDoc.data();
    if (!surveyTemplate) {
      throw new NotFoundError('Ce formulaire est invalide.');
    }

    const surveyAnswer = this.surveys.initSurveyAnswer(surveyTemplate);

    // Don't save survey until the final validation
    return { surveyTemplate, surveyAnswer, responseId: undefined };
  }

  submit(_reference: string, answer: SurveyAnswer) {
    return this.evaluator.evaluateSurvey(answer).pipe(take(1));
  }
}
